import type { NodeProps } from '../types';

export interface MarketplaceFieldProps extends Record<string, unknown> {
  id: string;
  field: string;
  marketplaceField?: {
    value: string;
    isActive: boolean;
  };
}

export function MarketplaceField({ props }: NodeProps<MarketplaceFieldProps>) {
  return <>{props.marketplaceField?.value}</>;
}
